import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import UpButton from '../up-button';
import globalMessages from '../../messages/globalMessages';

import { Wrapper, Error, ResetButton as UpResetButton } from './styles';

interface UpCustomerSettingsButtonFooterBaseProps {
  errorMessage?: React.ReactNode,
  resetButtonDisabled?: boolean;
  saveButton?: boolean;
  saveButtonType?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  saveButtonDisabled: boolean;
  saveButtonOnClick: () => void;
  saveButtonValue?: React.ReactNode;
  saving?: boolean;
  className?: string;
  reverse?: boolean;
  gTagId?: string;
}

interface UpCustomerSettingsButtonFooterWithResetProps {
  resetButton?: true;
  resetButtonOnClick: () => void;
}

interface UpCustomerSettingsButtonFooterWithoutResetProps {
  resetButton: false;
  resetButtonOnClick?: undefined;
}

type UpCustomerSettingsButtonFooterProps = UpCustomerSettingsButtonFooterBaseProps &
  (
    | UpCustomerSettingsButtonFooterWithResetProps
    | UpCustomerSettingsButtonFooterWithoutResetProps
  );

const UpCustomerSettingsButtonFooter = (props: UpCustomerSettingsButtonFooterProps) => {
  const {
    saving,
    saveButtonType,
    saveButtonValue,
    saveButtonDisabled,
    saveButtonOnClick,
    resetButtonDisabled,
    errorMessage,
    className,
    reverse = false,
    gTagId,
  } = props;

  return (
    <Wrapper
      className={classNames(className, { reverse })}
      errorMessage={errorMessage}
    >
      <>
      {errorMessage && <Error>{errorMessage}</Error>}
      {saveButtonOnClick && (
        <UpButton
          gTagId={gTagId}
          loading={saving}
          value={
            saveButtonValue || <FormattedMessage {...globalMessages.saveButton} />
          }
          onClick={() => saveButtonOnClick()}
          disabled={saveButtonDisabled || saving}
          type={saveButtonType || 'button'}
        />
      )}
      {props.resetButton === undefined || props.resetButton ? (
        <UpResetButton
          value={
            <FormattedMessage
              id="containers.Dashboard.discardChangesButton"
              defaultMessage="Discard changes"
            />
          }
          type="button"
          disabled={resetButtonDisabled || saving}
          onClick={props.resetButtonOnClick}
          margin="0 20px"
        />
      ) : null}
      </>
    </Wrapper>
  );
};

UpCustomerSettingsButtonFooter.propTypes = {
  errorMessage: PropTypes.any,
  resetButton: PropTypes.bool,
  resetButtonDisabled: PropTypes.bool,
  resetButtonOnClick: PropTypes.func,
  saveButton: PropTypes.bool,
  saveButtonType: PropTypes.string,
  saveButtonDisabled: PropTypes.bool,
  saveButtonOnClick: PropTypes.func,
  saveButtonValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  saving: PropTypes.bool,
  className: PropTypes.string,
  reverse: PropTypes.bool,
};

export default UpCustomerSettingsButtonFooter;
